import { render } from "./Main.vue?vue&type=template&id=b657e0f6"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src689428801/src/mess-barcode-scan-req-serv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__